<template>
    <div
        class="modal modal__product-combinations fade"
        :id="`product_search_modal_${pageType}_${item.id_product}`"
        tabindex="-1"
        role="dialog"
        aria-labelledby="addToCartModalLabel"
        aria-hidden="true"
    >
        <div class="modal-dialog modal-dialog__product-combinations" role="document">
            <div class="modal-content modal-content__product-combinations w-100">
                <form
                    class="col-12 px-0"
                    :name="`buy_${selectedCombination?.id_product_attribute}`"
                    :action="item.link_to_cart"
                >
                    <div class="modal-header modal-header__product-combinations">
                        <h5
                            class="modal-title algolia-listing-product-block__modal-title"
                            id="addToCartModalLabel"
                        >
                                    <span
                                        class="algolia-listing-product-block__variant-count algolia-listing-product-block__variant-count--mobile"
                                    >{{ item.combinations_text }}</span>
                                <span class="algolia-listing-product-block__variant-count--span">{{ $t("algoliaSearch.hitItemFromLabel") }}</span>
                                <span
                                    class="algolia-listing-product-block__variant-count--mobile"
                                >{{
                                        item.price_tax_incl_from_display
                                    }}</span
                                >
                        </h5>

                        <button
                            data-dismiss="modal"
                            aria-label="Close"
                            class="modal__header-button"
                        >
                            <i class="fa fa-times"></i>
                        </button>
                    </div>
                    <div class="modal-body modal-body__product-combinations">
                        <ProductCombinationsMobile
                            :combinations="item.combinations"
                            :id-product="item.id_product"
                            :link-to-cart="item.link_to_cart"
                            :query-id="item.__queryID"
                            :position="item.__position"
                            :object-id="item.objectID"
                            :lang-iso="langIso"
                            @selectedCombination="selectedCombination = $event"
                        />
                    </div>

                    <div class="modal-footer__product-combinations row"
                    :class="[item.combinations.length > 4 ? 'modal-footer__box-shadow' : '']">
                        <div v-html="deliveryEstimateHtml">
                        </div>

                        <div class="col-3">
                            <input
                                type="hidden"
                                name="id_product"
                                :value="item.id_product"
                            />
                            <input
                                type="hidden"
                                name="id_product_attribute"
                                :value="selectedCombination?.id_product_attribute"
                            />
                            <input
                                type="hidden"
                                name="minimal_quantity"
                                value="1"
                            />
                            <input type="hidden" name="add" :value="true" />
                            <div class="modal__quantity-select-wrapper">
                                <AmountInput
                                        :id-product-attribute="selectedCombination?.id_product_attribute"
                                        :id-product="item.id_product"
                                        :is-mobile="true"
                                />
                            </div>
                        </div>
                        <div class="col-9">
                            <button
                                v-if="selectedCombination === null"
                                @click.prevent="onAddToCartClick"
                                class="modal__buy-button"
                            >
                                <span>{{ $t('blockCart.addToCart') }}</span><i class="fa fa-shopping-cart ml-3"></i>
                            </button>

                            <button
                                v-else-if="hasUnavailableStatus(selectedCombination)"
                                @click.prevent="handleOutOfStock(selectedCombination)"
                                class="algolia-listing-product-block__buy-button algolia-listing-product-block__buy-button--unavailable"
                            >
                                <i class="fa fa-envelope"></i>
                            </button>

                            <button
                                v-else
                                class="modal__buy-button product-list__item__add-to-cart-button"
                                :data-id-product="item.id_product"
                                :data-query-id="item.__queryID"
                                :data-position="item.position"
                                :data-object-id="item.objectID"
                                :data-is-mobile="true"
                                :data-id-product-attribute="selectedCombination.id_product_attribute"
                                @click="$emit('buy')"
                            >
                                <span>{{ $t('blockCart.addToCart') }}</span>
                                <i class="fa fa-shopping-cart ml-3"></i>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import ProductCombinationsMobile from "./ProductCombinationsMobile";
import AmountInput from "./Inputs/AmountInput.vue";

export default {
    name: "ProductCombinationsModal",
    components: { AmountInput, ProductCombinationsMobile },
    props: {
        item: {
            type: Object,
            required: true
        },
        langIso: {
            type: String,
            required: false,
            default: 'nl-NL',
        },
        pageType: {
            type: String,
            required: true
        },
    },
    data() {
        return {
            selectedCombination: null,
            deliveryEstimateHtml: '',
        }
    },
    mounted() {
        const deliveryEstimateElementOriginal = document.getElementById('brekz_delivery_estimate');

        if (deliveryEstimateElementOriginal) {
            const deliveryEstimateElement = deliveryEstimateElementOriginal.cloneNode(true);

            deliveryEstimateElement.id            = '';
            deliveryEstimateElement.style.display = 'flex';

            this.deliveryEstimateHtml = deliveryEstimateElement.outerHTML;
        }
    },
    methods: {
        onAddToCartClick(id_product, id_combination, minimal_quantity) {
            if (! this.selectedCombination) {
                window.EventBus.$emit('open-price-display-explanation-modal');
            }
        },
        handleOutOfStock(combination) {
            if (!combination) {
                return false;
            }

            this.$emit('out-of-stock');

            $("#out-of-stock-opt-in-modal").removeClass("d-none").css('z-index', 3000);
            $("#out-of-stock-optin-attribute").val(combination.id_product_attribute);
        },
        hasUnavailableStatus(combination) {
            if (!combination) {
                return false;
            }

            return (
                !combination.available_now ||
                combination.unavailable_status_text
            );
        }
    }
};
</script>
